import React from "react";

import { DismissiblePopup } from "./DismissiblePopup";

import { useGoalCoachEnabled } from "../hooks/useGoalCoachEnabled";

import { useAskPerformYardStore } from "../AskPerformYardStore";

export const GoalCoachPopup: React.FC = () => {
	const goalCoachEnabled = useGoalCoachEnabled();
	const isOnGoalCreationPage = useAskPerformYardStore((state) => state.isOnGoalCreationPage);
	const isOpen = useAskPerformYardStore((state) => state.isOpen);
	const open = useAskPerformYardStore((state) => state.open);
	const setPendingGoalCoachStart = useAskPerformYardStore((state) => state.setPendingGoalCoachStart);

	const handleStart = (): void => {
		open();
		setPendingGoalCoachStart(true);
	};

	return (
		<DismissiblePopup
			popupKey="goal-coach"
			enabled={goalCoachEnabled && isOnGoalCreationPage && !isOpen}
			title="Want help strengthening this goal?"
			action={{ label: "Suggest improvements", onClick: handleStart }}
		/>
	);
};

export default GoalCoachPopup;
